import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DetailViewFormBuilderService } from '../../../../shared/service/detail-view-form-builder.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ArbeitsbereichService } from '../../../../shared/service/arbeitsbereich.service';
import { MessageService } from '../../../../core/service/message.service';
import { DetailFormDataModel } from '../../../../config/model/detail-form-data.model';
import { RelatedFeatureParams } from '../../detail-view.model';

@Component({
    selector: 'related-feature-form',
    templateUrl: './related-feature-form.component.html',
    styleUrls: ['./related-feature-form.component.scss'],
    standalone: false
})
export class RelatedFeatureFormComponent implements OnInit, OnDestroy {
  @Input() viewExpanded: boolean;
  @Input() relatedFeatureParams: RelatedFeatureParams;

  public formGroup: UntypedFormGroup;
  public relatedFormModel: DetailFormDataModel;
  public formattedFormFields: any;

  constructor(
    private messageService: MessageService,
    private arbeitsbereichService: ArbeitsbereichService,
    private detailViewFormBuilderService: DetailViewFormBuilderService
  ) {}

  ngOnInit() {
    this.buildRelatedFeatureForm();
  }

  ngOnDestroy() {}

  /**
   * @name buildRelatedFeatureForm
   * @description Erstellet die projekt Form anhand der attribute von geklickten projektliste
   */
  private buildRelatedFeatureForm() {
    this.relatedFormModel = this.arbeitsbereichService.setRelatedFormDataModel(this.relatedFeatureParams);

    // build object json um den Form zu erstellen anhand die featurelayer felds und die Konfigurationsfelder
    this.formattedFormFields = this.detailViewFormBuilderService.buildFormJson(
      this.relatedFormModel.selectedFeatureFields,
      this.relatedFormModel.configFormFields
    );

    if (this.formattedFormFields) {
      // initial neues FormGroup für geklicktes Graphic
      this.formGroup = new UntypedFormGroup({
        initial: new UntypedFormControl('initial'),
      });
      this.formGroup.markAsTouched();
    } else {
      this.messageService.error('NOTIFICATIONS.ERROR.OPEN_DETAILVIEW_INVALID');
    }
  }
}
